import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { DigisubservicesService } from 'src/app/services/digisubservices.service';

@Component({
  selector: 'app-add-book-per-price',
  templateUrl: './add-book-per-price.component.html',
  styleUrls: ['./add-book-per-price.component.scss'],
})
export class AddBookPerPriceComponent implements OnInit {
  bookreceipt;
  bookdata = [];
  updatedBooks = [];
  initial_total_val: number = 0;
  crdtvAmt = 0;
  selectedAmt = 0;
  balanceAmt = 0;
  bal =0;
  bname:any;
  formatDateToDDMMYYYY: any;
  getPublishDate: any;

  constructor(
    public service: DigisubservicesService,
    private fb: FormBuilder,
    private dialogRef: MatDialogRef<AddBookPerPriceComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
   
  }

  ngOnInit(): void {
    debugger;
    this.bookreceipt = this.data['book'];

    this.crdtvAmt = isNaN(this.data['crdtAmt']) ? 0 : this.data['crdtAmt'];
    this.selectedAmt = isNaN(this.data['seAmt']) ? 0 : this.data['seAmt'];
    this.balanceAmt = isNaN(this.data['balAmt']) ? 0 : this.data['balAmt'];
    this.bal = isNaN(this.data['bal']) ? 0 : this.data['bal'];
    this.bname = this.data?.['bookName'] ?? '';

    console.log(this.bname);
    console.log('rcpt data', this.bookreceipt);

    // const fetchBooks = this.bookreceipt['invoice_no'].includes('BDO')
    // ? this.service.getRcptWiseBooks1(this.bookreceipt['order_no'])
    // : this.service.getRcptWiseBooks(this.bookreceipt['order_no']);
    const fetchBooks =  this.service.getRcptWiseBooks(this.bookreceipt['order_no']);

    fetchBooks.subscribe((data) => {
      console.log({ data });
      // this.total_val = 0;
      // this.total_remaining_amt = 0;
    
      data.forEach((book) => {
        const total_amount = parseInt(book['total']) + parseInt(book['shipping_charges']);
        const rcvd_amt = parseInt(book['received_amt']) || 0;
        const remaining_amt:number = total_amount - rcvd_amt;
    
        this.total_val += rcvd_amt;
        this.total_remaining_amt += remaining_amt;
    
        this.bookdata.push({
          id: this.bookreceipt['id'],
          bookid: book['bd_id'],
          book_name: book['book_name'],
          book_price: book['book_price'],
          book_copies: book['book_copies'],
          total: book['total'],
          shipping_charges: book['shipping_charges'],
          rep_name: book['rep_name'],
          office_rep_name: book['office_rep_name'],
          mobile: book['mobile'],
          total_amount: total_amount,
          rcvd_amt: rcvd_amt,
          remaining_amt: remaining_amt,
          invoice_no: this.bookreceipt['invoice_no'],
          isDisabled: remaining_amt === 0 || remaining_amt === 0.00,
          order_no:book['order_no']
        });
      });
      console.log("data",this.bookdata)
    });
    
}

  total_remaining_amt = 0;
  total_val = 0;
  value = 0;
  newvalue=0;

 calcamount(event: any, book: any) {
  debugger;
  let val = parseInt(event.target.value) || 0; // ensure number

  // ✅ 1. Check: entered value cannot be more than book's remaining amount
  let remaining_amt_check =
    parseInt(book['total_amount']) - parseInt(book['rcvd_amt']);

  if (val > remaining_amt_check) {
    alert(" Received amount cannot be greater than book's remaining amount!");
    event.target.value = ""; // reset input
    return; // stop further execution
  }

  // ✅ 2. Check: entered value cannot be more than credit voucher amount
  if (val > this.crdtvAmt) {
    alert(" Received amount cannot be greater than Credit Voucher Amount!");
    event.target.value = "";
    return;
  }

  if (this.newvalue == 0) {
    this.newvalue = val;
  } else {
    this.newvalue += val;
  }

  this.newvalue = val;
  this.total_val = 0;

  let remaining_amt =
    parseInt(book['total_amount']) -
    (parseInt(book['rcvd_amt']) + val);

  this.total_remaining_amt = 0;

  let updatedBook = { ...book };
  updatedBook['rcvd_amt'] = val;
  updatedBook['remaining_amt'] = remaining_amt;
  updatedBook['isDisabled'] = remaining_amt === 0 || remaining_amt === 0.0;

  let index = this.updatedBooks.findIndex(b => b.bookid === book.bookid);
  if (index !== -1) {
    this.updatedBooks[index] = updatedBook;
  } else {
    this.updatedBooks.push(updatedBook);
  }

  for (let index = 0; index < Object.keys(this.bookdata).length; index++) {
    if (this.bookdata[index]['bookid'] == book['bookid']) {
      this.bookdata[index]['rcvd_amt'] = val;
      this.value = this.value + val;
      this.bookdata[index]['remaining_amt'] = remaining_amt;
      this.bookdata[index]['isDisabled'] =
        remaining_amt === 0 || remaining_amt === 0.0;

      this.selectedAmt = this.selectedAmt + Number(this.newvalue);
      this.balanceAmt = this.crdtvAmt - this.selectedAmt;
    }
    debugger;
    this.total_val =
      this.total_val + parseInt(this.bookdata[index]['rcvd_amt']);
    this.total_remaining_amt =
      this.total_remaining_amt +
      parseInt(this.bookdata[index]['remaining_amt']);
  }
  console.log("bookdata", this.bookdata);
}


  save() {
    console.log(this.value);

    this.dialogRef.close({
      data: this.updatedBooks,
      selecetdAmt: this.selectedAmt,
      remaining_amt: this.total_remaining_amt,
      value: this.value,
      balanceAmt: this.balanceAmt,
      id: this.bookreceipt['id'],
    });
    // if (confirm('This operation is not reversable. Do you want to proceed.')) {
    //   for (let index = 0; index < Object.keys(this.bookdata).length; index++) {
    //     this.service
    //       .updateRcptWiseBooks(
    //         this.bookdata[index]['bookid'],
    //         this.bookdata[index]['rcvd_amt'],
    //         this.bookdata[index]['remaining_amt']
    //       )
    //       .subscribe((data) => {
    //         console.log(data);
    //         alert('Books price added successfully...');
    //         // this.dialogRef.close();
    //       });
    //   }
    // }
  }
}
